import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
// Models
import { EventSubscriptionType, EventType, EventModel } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
// Services
import { RoutesService } from '../../../../services/routes.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { SwalService } from '../../../../shared/services/swal.service';
// Components
import { RutasEditCreateComponent } from './modal/edit-create/edit-create.component';

@Component({
    selector: 'app-rutas',
    templateUrl: './rutas.component.html',
    styleUrls: ['./rutas.component.scss']
})
export class RutasComponent implements OnInit, OnDestroy {

    dtConfig = {
        config: {
            base: this.routesService,
            api: 'datatable',
            rowsPerPage: 15,
            order: [[2, 'desc']]
        },
        columns: [
            {
                title: 'ID',
                field: 'id'
            },
            {
                title: 'Nombre',
                field: 'name'
            },
            {
                title: 'Descr',
                field: 'description'
            },
            {
                title: 'Activo',
                field: 'active',
                type: 'boolean'
            }
        ],
        actions: [
            {
                display: 'Editar',
                icon: 'fa-pencil',
                event: 'routes.edit',
                conditionality: 'true'
            },
            {
                display: 'Eliminar',
                icon: 'fa-trash',
                event: 'routes.delete',
                conditionality: 'true'
            }
        ]
    };

    bc$: any;

    constructor(
        public modalRef: BsModalService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private broadcast: BroadcastService,
        private nrModal: NRModalService,
        private swal: SwalService,
        private routesService: RoutesService,
    ) { }

    ngOnDestroy(): void {
        if (this.bc$) {
            this.bc$();
        }
    }

    ngOnInit(): void {
        this.bc$ = this.broadcast.on(EventSubscriptionType.TYPE, EventType.MODAL, (event: EventModel) => {
            const props = this.prepareProps(event);
            if (props) {
                this.nrModal.open(props);
            }
        });
    }

    prepareProps(event: EventModel): any {
        const props: DynamicHostModel = new DynamicHostModel;
        props.instantiated = false;
        props.modalModel = {
            component: null,
            componentFactoryResolver: this.componentFactoryResolver,
            data: event.data.item || {}
        };

        switch (event.name) {
            case 'routes.add':
                props.modalModel.component = RutasEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Agregar Ruta'
                };
                break;

            case 'routes.edit':
                props.modalModel.component = RutasEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Editar Ruta'
                };
                break;

            case 'routes.delete':
                this.delete(event.data);
                return false;
                break;
        }

        return props;
    }

    /**
   * 
   */
    add(): void {
        this.broadcast.fire({
            name: 'routes.add',
            type: EventType.MODAL,
            data: {}
        });
    }

    /**
   * 
   * @param data 
   */
    delete(data): void {
        const swalParams = {
            title: `¿Estás seguro de querer eliminar el código ${data.item.name}?`
        };

        this.swal.warning(swalParams).then(result => {
            if (result.value) {
                this.routesService.delete(data.item.id).subscribe((resp: any) => {
                    if (resp.success) {
                        this.swal.success({ title: 'Código de error eliminado exitosamente' }).then(() => {
                            this.modalRef.hide(0);
                            this.broadcast.reloadDataTable();
                        });
                    } else {
                        this.swal.error('Ocurrio un error al intentar borrar el código de error');
                    }
                });
            }
        });
    }

}
